import { render, staticRenderFns } from "./rezervasyonekleridialog.vue?vue&type=template&id=5f67013e"
import script from "./rezervasyonekleridialog.vue?vue&type=script&lang=js"
export * from "./rezervasyonekleridialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports